import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: (() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user?.settings || [];
    } catch {
      return [];
    }
  })(),
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    updateSettings: (state, action) => {
      if (!action.payload || action.payload.length === 0) {
        state.settings.splice(0, state.settings.length);
      }
      action.payload.forEach(updated => {
        const existing = state.settings.find(
          s => s.settingName === updated.settingName
        );
        if (existing) {
          existing.settingValue = updated.settingValue;
        } else {
          state.settings.push(updated);
        }
      });

      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        user.settings = state.settings;
        localStorage.setItem("user", JSON.stringify(user));
      }
    },
  },
});

export const { updateSettings } = settingsSlice.actions;
export default settingsSlice.reducer;